import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/templates/page-mdx.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3 {...{
      "id": "product-license",
      "style": {
        "position": "relative"
      }
    }}>{`Product License`}</h3>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Note`}</strong>{`: This license relates to versions prior to Notifee being made free and Open Source. Licensing going forwards
is available via `}<a parentName="p" {...{
          "href": "https://github.com/invertase/notifee/blob/main/LICENSE"
        }}>{`the repository license`}</a>{`.`}</p>
    </blockquote>
    <p>{`The terms of the product license are set out below.`}</p>
    <hr></hr>
    <p>{`LICENSE`}</p>
    <p>{`Notifee;`}</p>
    <p>{`Copyright (c) 2019, Invertase Limited (UK), All rights reserved.`}</p>
    <hr></hr>
    <ol>
      <li parentName="ol">{`Preamble`}</li>
    </ol>
    <hr></hr>
    <p>{`This Agreement governs the relationship between YOU OR THE ORGANIZATION ON WHOSE BEHALF YOU ARE ENTERING INTO THIS
AGREEMENT (hereinafter: Licensee) and Invertase Limited, a LICENSOR whose principal place of business is in the United
Kingdom (hereinafter: Licensor).`}</p>
    <p>{`This Agreement sets the terms, rights, restrictions and obligations on using the purchased Notifee product
(hereinafter: the Software) created and owned by Licensor, as detailed herein.`}</p>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Grant of License`}</li>
    </ol>
    <hr></hr>
    <p>{`The Licensor hereby grants Licensee a Personal, Non-assignable & non-transferable, Commercial, Royalty free, Including
the rights to create but not distribute derivative works, Non-exclusive license, all with accordance with the terms set
forth and other legal restrictions set forth in 3rd party software used while running Software.`}</p>
    <ul>
      <li parentName="ul">{`2.1 Limited
Licensee may use Software for the purpose of:`}<ul parentName="li">
          <li parentName="ul">{`Running the Software on Licensee's Android and or iOS devices, Website(s) and Server(s);`}</li>
          <li parentName="ul">{`Allowing 3rd Parties to run the Software on Licensee's Android and or iOS devices, Website(s) and Server(s);`}</li>
          <li parentName="ul">{`Publishing the Software's output to Licensee and 3rd Parties;`}</li>
          <li parentName="ul">{`Distribute verbatim copies of Software's output (including compiled binaries);`}</li>
          <li parentName="ul">{`Modify Software to suit the Licensee’s needs and specifications.`}</li>
        </ul></li>
      <li parentName="ul">{`2.2 Binary Restricted
Licensee may sublicense Software as a part of a larger work containing more than Software, distributed solely in
Object or Binary form under a personal, non-sublicensable, limited license. Such redistribution shall be limited
to unlimited codebases.`}</li>
      <li parentName="ul">{`2.3 Non Assignable & Non-Transferable
Licensee may not assign or transfer his rights and duties under this license.`}</li>
      <li parentName="ul">{`2.4 Commercial, Royalty Free
Licensee may use the Software for any purpose, including paid-services, without any royalties`}</li>
      <li parentName="ul">{`2.5 Including the Right to Create Derivative Works
Licensee may create derivative works based on the Software, including amending Software’s source code, modifying
it, integrating it into a larger works or removing portions of the Software, as long as no distribution of the
derivative works source code is made.`}</li>
      <li parentName="ul">{`2.6 Number of Usages
Licensee may use the software for a single cross-platform application only, e.g. a separate iOS app and Android app
together count as one 'single cross-platform application'.`}</li>
    </ul>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`Term & Termination`}</li>
    </ol>
    <hr></hr>
    <p>{`The Term of this license shall be until terminated. Licensor may terminate this Agreement, including Licensees license
in the case where the Licensee:`}</p>
    <ul>
      <li parentName="ul">{`3.1:
became insolvent or otherwise entered into any liquidation process; or`}</li>
      <li parentName="ul">{`3.2:
exported The Software to any jurisdiction where licensor may not enforce his rights under this agreements in; or`}</li>
      <li parentName="ul">{`3.3:
Licensee was in breach of any of this license's terms and conditions and such breach was not cured, immediately
upon notification; or`}</li>
      <li parentName="ul">{`3.4:
Licensee in breach of any of the terms of clause 2 to this license; or`}</li>
      <li parentName="ul">{`3.5:
Licensee otherwise entered into any arrangement which caused Licensor to be unable to enforce his rights under
this License.`}</li>
      <li parentName="ul">{`3.6:
Licensee is refunded their FEE in full as laid out in clauses 4 and 9.`}</li>
    </ul>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`Payment`}</li>
    </ol>
    <hr></hr>
    <p>{`In consideration of the License granted under clause 2, the Licensee shall pay Licensor a FEE, via any payment method
which the Licensor may deem adequate. Failure to perform payment shall construe as material breach of this Agreement.`}</p>
    <p>{`The Licensor, at their sole discretion, may choose to waive the FEE to license the Software and grant a Licensee a
license free of charge. Licenses granted free of charge are still subject to the other terms set out in this license.`}</p>
    <ol {...{
      "start": 5
    }}>
      <li parentName="ol">{`Upgrades, Updates and Fixes`}</li>
    </ol>
    <hr></hr>
    <p>{`Licensor may provide Licensee from time to time with Upgrades, Updates or Fixes, as detailed herein and according to
the Licensor's sole discretion. The Licensee hereby warrants they may, at their sole discretion, keep the Software
up to date and install relevant updates & fixes and purchase upgrades, according to the rates set by Licensor.`}</p>
    <p>{`Licensor shall provide any Upgrade, Update or Fix free of charge; however, nothing in this Agreement shall require
the Licensor to provide Upgrades, Updates or Fixes.`}</p>
    <ul>
      <li parentName="ul">{`5.1 Upgrades
For the purpose of this license, an Upgrade shall be a material amendment in the Software, which contains major
new features and or major improvements and shall be marked as a new 'major' version number. For example, should
the Licensee purchase the Software under version 3.x.x, an upgrade shall commence under number 4.0.0.`}</li>
      <li parentName="ul">{`5.2 Updates
For the purpose of this license, an update shall be a minor amendment in the Software, which may contain new
features or minor improvements and shall be marked as a new 'minor' version number. For example, should the
Licensee purchase The Software under version 3.2.x, an minor update shall commence under version number 3.3.0.`}</li>
      <li parentName="ul">{`5.3 Fix
For the purpose of this license, a fix shall be a patch amendment in the Software, intended to fix bugs or alter
minor features which impair the the Software's functionality. A fix shall be marked as a new 'patch' version
number. For example, should Licensee purchase Software under version 3.2.1, an patch shall commence under version
number 3.2.3.`}</li>
    </ul>
    <ol {...{
      "start": 6
    }}>
      <li parentName="ol">{`Support`}</li>
    </ol>
    <hr></hr>
    <p>{`Software is provided under an AS-IS basis and without any guaranteed support, updates or maintenance. Nothing in this
Agreement shall require the Licensor to provide the Licensee with support or fixes to any bug, failure, performance
issue or other defect in the Software.`}</p>
    <p>{`6.1 Notifying the Licensor of bugs
Licensee may provide Licensor of details regarding any bug, defect or failure in the Software promptly and with
no delay from such event; Licensee shall comply with Licensor's reasonable requests for information regarding
bugs, defects or failures, and, furnish the Licensor with information, screenshots and try to reproduce such bugs,
defects or failures.`}</p>
    <p>{`6.2 Feature Requests
Licensee may request additional features in the Software, provided however, that`}</p>
    <ul>
      <li parentName="ul">{`(i) Licensee shall waive any claim or right in any such feature should the feature be developed by the Licensor;`}</li>
      <li parentName="ul">{`(ii) Licensee shall be prohibited from developing the feature, or disclose such feature request, or feature,
to any 3rd party directly competing with Licensor or any 3rd party which may be following the development
of such features or in direct competition with Licensor;`}</li>
      <li parentName="ul">{`(iii) Licensee warrants that the feature does not infringe any 3rd party patent, trademark, trade-secret or any
other intellectual property right; and`}</li>
      <li parentName="ul">{`(iv) the Licensee developed, envisioned or created the feature solely`}</li>
    </ul>
    <ol {...{
      "start": 7
    }}>
      <li parentName="ol">{`Liability`}</li>
    </ol>
    <hr></hr>
    <p>{`To the extent permitted under Law, The Software is provided under an AS-IS basis. Licensor shall never, and without any
limit, be liable for any damage, cost, expense or any other payment incurred by the Licensee as a result of the
Software’s actions, failure, bugs and/or any other interaction between the Software and Licensee’s equipment,
applications, computers, other software or any 3rd party equipment, computers, applications or services. Moreover,
Licensor shall never be liable for any defect in code written by Licensee when relying on the Software or using the
Software’s code.`}</p>
    <ol {...{
      "start": 8
    }}>
      <li parentName="ol">{`Warranty`}</li>
    </ol>
    <hr></hr>
    <ul>
      <li parentName="ul">{`8.1 Intellectual Property
Licensor hereby warrants that the Software does not violate or infringe any 3rd party claims in regards to
intellectual property, patents and/or trademarks and that to the best of its knowledge no legal action has been
taken against it for any infringement or violation of any 3rd party intellectual property rights.`}</li>
      <li parentName="ul">{`8.2 No-Warranty
The Software is provided without any warranty; Licensor hereby disclaims any warranty that the Software shall be
error free, without defects or code which may cause damage to Licensee’s computers, Licensee's software or to the
Licensee, and that Software shall be functional. Licensee shall be solely liable to any damage, defect or loss
incurred as a result of operating the Software and undertake the risks contained in running the Software.`}</li>
      <li parentName="ul">{`8.3 Prior Inspection
Licensee hereby states that they have inspected the Software thoroughly and found it satisfactory and adequate to
their needs, that it does not interfere with their regular operation and that meets the standards and scope of
their computer systems, applications, users, and architecture. Licensee found that the Software interacts with
their code, website, application, and server environment and that it does not infringe any of End User License
Agreement of any software Licensee may use in performing their services. Licensee hereby waives any claims
regarding the Software's incompatibility, performance, results and features, and warrants that they inspected the
Software.`}</li>
    </ul>
    <ol {...{
      "start": 9
    }}>
      <li parentName="ol">{`Refunds`}</li>
    </ol>
    <hr></hr>
    <p>{`Licensee warrants that they inspected the Software according to clause 8.3 and that it is adequate to their needs.
Accordingly, as the Software is intangible goods, the Licensee shall not be, ever, entitled to any refund, rebate,
compensation or restitution for any reason whatsoever, even if the Software contains material flaws.`}</p>
    <p>{`The Licensor however, at their sole discretion, may choose to grant a refund to the Licensee either partially or in
full. Full refunds of the FEE revoke the Licensees license as per clause 3(6).`}</p>
    <ol {...{
      "start": 10
    }}>
      <li parentName="ol">{`Indemnification`}</li>
    </ol>
    <hr></hr>
    <p>{`Licensee hereby warrants to hold the Licensor harmless and indemnify the Licensor for any lawsuit brought against it in
regards to Licensee’s use of the Software in means that violate, breach or otherwise circumvent this license,
Licensor's intellectual property rights or Licensor's title in the Software. Licensor shall promptly notify Licensee
in case of such legal action and request Licensee's consent prior to any settlement in relation to such lawsuit or
claim.`}</p>
    <p>{`Licensee hereby agrees not to initiate lawsuits against Licensor in relation to this license and to
compensate Licensor for any legal fees, costs, or attorney fees should any claim brought by the Licensee against the
Licensor be denied, in part or in full.`}</p>
    <ol {...{
      "start": 11
    }}>
      <li parentName="ol">{`Governing Law, Jurisdiction`}</li>
    </ol>
    <hr></hr>
    <p>{`This license and any dispute or claim arising out of or in connection with it or its subject matter or formation shall
be governed by and construed in accordance with the law of England and Wales. Each party irrevocably agrees that the
courts of England and Wales shall have exclusive jurisdiction to settle any dispute or claim arising out of or in
connection with this license or its subject matter or formation.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      